export default {
  toolbar: [
    [{ header: [1, 2, 3, 4, 5, false] }],
    ['bold', 'italic', 'strike'],
    ['blockquote'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ align: ['', 'center'] }],
    [{ script: 'sub' }, { script: 'super' }],
    ['clean'],
    ['link', 'video', 'image']
  ]
}
